import {
  http
} from "@/http/http.js";

//查询报表
export function queryReport(params) {
  return http.post("/web/report/queryReport", params);
}

//根据道路ID查询管道管井信息
export function queryPipeByRoadId(params) {
  return http.post("/web/report/queryPipeByRoadId", params);
}

//根据街道查询道路
export function queryRoadByTownCode(params) {
  return http.post("/web/report/queryRoadByTownCode", params);
}

//查询街道
export function queryTown(params) {
  return http.post("/web/report/queryTown", params);
}